import React from "react";

export const UserInfoContext = React.createContext<any>({});
